import downloadFile from "./downloadFile";
import toCsv from "./toCsv";

/**
 * Serializes a matrix of pre-stringified cells (first row = header) to CSV text
 * and triggers a browser download of `<fileNameWithoutExtension>.csv`.
 */
const downloadCsv = (fileNameWithoutExtension: string, rows: string[][]): void => {
  downloadFile(
    `${fileNameWithoutExtension}.csv`,
    new Blob(["\uFEFF", toCsv(rows)], { type: "text/plain" })
  );
};

export default downloadCsv;
